// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Y2yBg","image":"styles_image__RjBga","hints":"styles_hints__YXqKr"};